import {type IconName, Pill} from '@wandb/components';
import React from 'react';

export interface MentionPillProps {
  icon: IconName;
  text: string;
  tooltip?: {children: React.ReactNode};
}

/**
 * MentionPill is the shared inline pill for wandb mention data parts (run,
 * conversation, workspace panel, etc.) rendered inside a user message.
 */
export const MentionPill = ({icon, text, tooltip}: MentionPillProps) => (
  <Pill icon={icon} textValue={text} tooltip={tooltip} />
);
